import { render, staticRenderFns } from "./NewsIsPrivate.vue?vue&type=template&id=a30c94a2&scoped=true"
var script = {}
import style0 from "./NewsIsPrivate.vue?vue&type=style&index=0&id=a30c94a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30c94a2",
  null
  
)

export default component.exports